import analytics from '../../../api/analytics'
import { mapMutations, mapActions } from 'vuex'
import { mask } from 'vue-the-mask'
import CardForm from '../../common/CardForm'
import AdvancedSelect from '../../common/AdvancedSelect'
import { scrollToElement } from '@/utils/window-utils'

const mixin = {
  props: {
    item: Object,
    patient: Object,
    isExamProfiles: Boolean,
    index: Number,
    disableDeletion: {
      default: false,
      type: Boolean
    }
  },
  data: () => ({
    codePsa: [
      'PPPH',
      'PSA',
      'PSA2',
      'PSA3',
      'PSA2PE',
      'PSA2RJ',
      'PSAL',
      'PSALPE',
      'PSAPE',
      'PHI',
      'PDST',
      'PATMATER',
      'PAT',
      'PATDUO',
      'PATRECONS'
    ]
  }),
  components: {
    'card-form': CardForm,
    'advanced-select': AdvancedSelect
  },
  directives: {
    mask: mask
  },
  methods: {
    ...mapActions(['deleteOrderExams', 'sucessAddNewExam']),
    ...mapMutations({
      updateExam: 'EXAM_UPDATE_NEW',
      editExam: 'EXAM_SET_EDITING'
    }),
    openModal(code) {
      this.$nextTick(() => {
        if (this.$refs.examsModalAlert) {
          this.$refs.examsModalAlert.openModal(code)
        } else {
          console.error('Componente examsModalAlert não encontrada.')
        }
      })
    },
    validateBeforeSubmit(evt) {
      return new Promise((resolve, reject) => {
        if (evt && evt.keyCode === 13 && evt.shiftKey) {
          resolve(false)
        } else {
          this.$validator.validateAll().then(result => {
            if (result) {
              this.beforeSucessAddNewExam()
              this.item.sample.collect_times = this.item.sample.collectTimes
              this.sucessAddNewExam(this.item)
              resolve(true)
            } else {
              this.analyticsForExamValidationErrors()
              resolve(false)
            }
            if (this.errors.items.length) {
              let elementName = this.errors.items[0].field
              let element = ''

              if (elementName === 'samples') {
                element = document.querySelectorAll(
                  '.exam-card-num-' + this.index + ' .exam-curve__curves__item input'
                )[0]
              } else if (elementName === 'material') {
                element = document.querySelector('.exam-card-num-' + this.index + ' #cboNewMaterial .multiselect')
              } else if (elementName === 'gender0') {
                element = document.querySelector('.exam-card-num-' + this.index + ' #gender .multiselect')
              } else {
                element = document.querySelector('.exam-card-num-' + this.index + ' [name="' + elementName + '"]')
              }
              scrollToElement(element)
              element.focus()
            }
          })
        }
      })
    },
    beforeSucessAddNewExam() {},
    analyticsForExamValidationErrors() {
      this.errors.all().forEach(function (errorMessage) {
        analytics.pushAnalyticsEvent('error-validation', { 'msg-error': errorMessage })
      })
    },
    analyticsSuccessInsertingExam(idExam) {
      analytics.pushAnalyticsEvent('addToCart', {
        ecommerce: {
          currencyCode: 'BRL',
          add: {
            products: [
              {
                name: '0',
                id: idExam
              }
            ]
          }
        }
      })
    },
    getAvailableMaterials() {
      if (!this.item.details.materials) {
        return []
      }
      let clonedMaterialArray = this.item.details.materials.slice(0)
      clonedMaterialArray.sort((a, b) => {
        if (a.name.toLowerCase() < b.name.toLowerCase()) {
          return -1
        }
        if (a.name.toLowerCase() > b.name.toLowerCase()) {
          return 1
        }
        return 0
      })
      clonedMaterialArray.map(function (elem) {
        elem.label = elem.id + ' - ' + elem.name
      })
      return clonedMaterialArray
    },
    preventRawEnterFromPropagation(event) {
      if (!event.altKey && !event.ctrlKey && !event.shiftKey && !event.metaKey) {
        event.preventDefault()
      }
    },
    validateOnMount() {
      if (
        Object.keys(this.$route.params).length !== 0 &&
        'id_exam_order' in this.item &&
        this.$route.query.exam !== this.item.id_exam_order.toString()
      ) {
        this.validateBeforeSubmit()
      }
    }
  },
  computed: {
    gender: {
      get() {
        if (this.patient && this.item && this.patient.gender && this.patient.gender.value) {
          let isGenderF = this.patient.gender.value === 'F'
          let isPsa = this.codePsa.includes(this.item.details.code)
          return { isGenderF, isPsa, func: this.openModal }
        } else if (this.patient && this.patient.gender) {
          return this.patient.gender
        }
        return null
      },
      set(value) {
        this.patient.gender = value
      }
    },
    isExamCollapsed: function () {
      return !this.item.editing
    },
    materialName: function () {
      return this.material ? this.material.name : ''
    },
    materialId: function () {
      return this.material ? this.material.id : ''
    },
    conditioning: function () {
      if (!this.material) {
        return ''
      }
      return this.material.conditioning
    },
    collectTimesOrdered() {
      if (typeof this.item.details.collectTimes === 'object') {
        let valuesArray = Object.values(this.item.details.collectTimes)

        valuesArray.sort((a, b) => a.order - b.order)

        let sortedObject = {}

        valuesArray.forEach(obj => {
          sortedObject[obj.order] = obj
        })
        return sortedObject
      } else if (this.item.details.collectTimes && this.item.details.collectTimes.length) {
        return this.item.details.collectTimes.sort((a, b) => a.order - b.order)
      } else {
        return this.item.details.collectTimes
      }
    }
  },
  mounted() {
    const code = this.item.details.code
    const isGenderF = this.patient && this.patient.gender && this.patient.gender.value === 'F'

    const codesToOpenModal = ['HIV4C', 'PDST', 'PATMATER', 'PAT', 'PATDUO', 'PATRECONS']

    if (codesToOpenModal.includes(code) || (this.codePsa.includes(code) && isGenderF)) {
      this.openModal(code)
    }
  },
  watch: {
    gender: newVal => {
      if (newVal.isGenderF && newVal.isPsa) {
        newVal.func(newVal.code)
      }
    }
  }
}

export default mixin
